'use client'

import dynamic from 'next/dynamic'

const JgglPromoBanner = dynamic(() => import('./index'), { ssr: false })

export default function JgglPromoBannerLazy() {
  return <JgglPromoBanner />
}
